import { GetMediaInfoResponse, MediaInfoThumbnail } from '@anm/api/modules/youtube';
import maxBy from 'lodash/fp/maxBy';

const getPreview = ({ thumbnail, thumbnails }: GetMediaInfoResponse) =>
  maxBy<MediaInfoThumbnail>(({ height }) => height)(thumbnails)?.url || thumbnail;

export default getPreview;
